import React from 'react';

const VideoEmbed = ({ src, title, caption }) => (
  <div className="w-full my-4 rounded-lg overflow-hidden">
    <div className="relative w-full pb-[56.25%]">
      <iframe
        src={src}
        title={title || "Embedded video"}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute inset-0 w-full h-full rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/70"
      />
    </div>
    {caption && (
      <div className="text-center text-gray-400 text-sm mt-3">{caption}</div>
    )}
  </div>
);

export default VideoEmbed; 